import React from "react";

import "./cart-item.styles.scss";

import { useTranslation } from "react-i18next";

const CartItem = ({ item: { imageUrl, price, name, quantity } }) => {
  const { t, i18n } = useTranslation();

  return (
    <div className="cart-item">
      <img src={imageUrl} alt="item" />
      <div className="item-details">
        <span className="name">{t(name)}</span>
        <span className="price">
          {quantity} x €{price}
        </span>
      </div>
    </div>
  );
};

export default CartItem;
